/* eslint-disable sonarjs/no-duplicate-string */
export default [
  // B2C PP ===================================================================
  {
    id: 'SP901',
    title: 'O~2~',
    brand: 'O~2~',
    brandId: '1',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://o2online.de/goto/datenschutzmerkblatt',
  }, {
    id: 'SP902',
    title: 'Blau',
    brand: 'Blau',
    brandId: '2',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://blau.de/goto/datenschutzmerkblatt',
  }, {
    id: 'SP903',
    title: 'Tchibo MOBIL',
    brand: 'Tchibo MOBIL',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://tchibo-mobil.de/rechtliches/datenschutz',
  },
  // B2P PP ===================================================================
  {
    id: 'SP904',
    title: 'AY YILDIZ',
    brand: 'AY YILDIZ',
    brandId: '72',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.ayyildiz.de/downloads/datenschutzmerkblatt.pdf',
  }, {
    id: 'SP905',
    title: 'Ortel Mobile',
    brand: 'blauworld',
    tenant: 'Ortel Mobile GmbH, 40472 Düsseldorf',
    description: 'Ortel Mobile GmbH, E-Plus-Straße 1, 40472 Düsseldorf',
    url: 'https://www.ortelmobile.de/rechtliches/datenschutz.html#c9967',
  }, {
    id: 'SP906',
    title: 'Ortel Mobile',
    brand: 'Mobilka',
    brandId: '74',
    tenant: 'Ortel Mobile GmbH, 40472 Düsseldorf',
    description: 'Ortel Mobile GmbH, E-Plus-Straße 1, 40472 Düsseldorf',
    url: 'https://www.ortelmobile.de/rechtliches/datenschutz.html#c9967',
  }, {
    id: 'SP907',
    title: 'NettoKOM',
    brand: 'NettoKOM',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.nettokom.de/content/dam/nettokom/documents/datenschutz.pdf',
  }, {
    id: 'SP908',
    title: 'novamobil',
    brand: 'novamobil',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.nova-mobil.de/documents/novamobil-datenschutz.pdf',
  }, {
    id: 'SP909',
    title: 'Ortel Mobile',
    brand: 'Ortel Mobile',
    tenant: 'Ortel Mobile GmbH, 40472 Düsseldorf',
    description: 'Ortel Mobile GmbH, E-Plus-Straße 1, 40472 Düsseldorf',
    url: 'https://www.ortelmobile.de/datenschutzmerkblatt',
  }, {
    id: 'SP910',
    title: 'WhatsApp SIM',
    brand: 'WhatsApp SIM',
    brandId: '78',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.whatsappsim.de/content/dam/whatsappsim/downloads-formulare/datenschutzmerkblatt.pdf',
  }, {
    id: 'SP911',
    title: 'Ortel Mobile',
    brand: 'Mobilka',
    tenant: 'Ortel Mobile GmbH, 40472 Düsseldorf',
    description: 'Ortel Mobile GmbH, E-Plus-Straße 1, 40472 Düsseldorf',
    url: 'https://www.ortelmobile.de/rechtliches/datenschutz.html#c9967',
  }, {
    id: 'SP912',
    title: 'ALDI TALK',
    brand: 'ALDI TALK',
    tenant: 'E-Plus Service GmbH, Düsseldorf',
    description: 'E-Plus Service GmbH, E-Plus-Straße 1, 40472 Düsseldorf',
    url: 'https://www.alditalk.de/datenschutzmerkblatt',
  }, {
    id: 'SP913',
    title: 'Ortel Mobile',
    brand: 'Spice Mobile',
    tenant: 'Ortel Mobile GmbH, 40472 Düsseldorf',
    description: 'Ortel Mobile GmbH, E-Plus-Straße 1, 40472 Düsseldorf',
    url: 'https://spicemobile.de/datenschutzmerkblatt',
  }, {
    id: 'SP602',
    title: 'FONIC',
    brand: 'FONIC',
    brandId: '42',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.fonic.de/dlc/pdf/FONIC_Datenschutzmerkblatt.pdf',
  },
  // B2C PO ===================================================================
  {
    id: 'SP301',
    title: 'O~2~',
    brand: 'O~2~',
    brandId: '1',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://o2online.de/goto/datenschutzmerkblatt',
  }, {
    id: 'SP302',
    title: 'Blau',
    brand: 'Blau',
    brandId: '2',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://blau.de/goto/datenschutzmerkblatt',
  },
  // B2P PO ===================================================================
  {
    id: 'SP303',
    title: 'TELEFÓNICA',
    brand: 'aetkaSMART',
    brandId: '65',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://o2online.de/goto/datenschutzmerkblatt',
  }, {
    id: 'SP304',
    title: 'AY YILDIZ',
    brand: 'AY YILDIZ',
    brandId: '72',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.ayyildiz.de/downloads/datenschutzmerkblatt.pdf',
  }, {
    id: 'SP306',
    title: 'mobilka.de',
    brand: 'mobilka.de',
    brandId: '74',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://o2online.de/goto/datenschutzmerkblatt',
  }, {
    id: 'SP308',
    title: 'Simfinity',
    brand: 'Simfinity',
    brandId: '70',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://o2online.de/goto/datenschutzmerkblatt',
  },
  // B2B ======================================================================
  {
    id: 'SP251',
    title: 'Telefónica',
    brand: 'Telefónica',
    brandId: '1',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.o2business.de/datenschutzmerkblatt',
  }, {
    id: 'SP252',
    title: 'Telefónica',
    brand: 'Telefónica',
    brandId: '1',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.o2business.de/datenschutzmerkblatt',
  }, {
    id: 'SP299',
    title: 'Telefónica',
    brand: 'Telefónica',
    brandId: '1',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Telefónica Germany GmbH & Co. OHG, Georg-Brauchle-Ring 50, 80992 München',
    url: 'https://www.o2business.de/datenschutzmerkblatt',
  }, {
    id: 'SPTEST',
    title: 'test',
    brand: 'test',
    brandId: '1',
    tenant: 'Telefónica Germany GmbH & Co. OHG, München',
    description: 'Test service provider for Config Tests',
    url: 'https://mucsggit02.sg.de.pri.o2.com/consent-management/configuration-cli',
  },
];
